import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    allEmployeesIcon: {
      cursor: 'pointer',
      color: legacyColors.blue,
      border: `1px solid ${legacyColors.grey5}`,
      borderRadius: '4px',
      minWidth: '38px',
      height: '36px',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        backgroundColor: 'initial',
      },
    },
    allEmployeesBoxOpen: {
      color: legacyColors.white,
      backgroundColor: legacyColors.blue,
      '&:hover': {
        backgroundColor: legacyColors.blue,
      },
    },
    infoBoxElementText: {
      border: 'none',
      fontWeight: 'bold',
      height: '36px',
      width: '217px',
      padding: '6px 12px',
    },
    infoBoxElementTextBtn: {
      cursor: 'pointer',
      color: legacyColors.grey7,
      verticalAlign: 'middle',
      fontSize: '14px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: legacyColors.white,
      border: `1px solid ${legacyColors.grey5}`,
      borderRadius: '4px',
      height: '36px',
      marginLeft: '5px',
    },
    infoBoxElementTextFullWidth: {
      flexGrow: 1,
    },
    infoBoxElementTextInput: {
      outline: 'none',
      fontFamily: 'arial, helvetica, sans-serif',
      fontSize: '14px',
    },
    searchIcon: {
      paddingRight: '12px',
      color: legacyColors.blue,
    },
  };
};
